module.exports = __webpack_public_path__ + "static/media/selec-nft-12.8dded4fb.png";